import '@adornis/buchungsheld-components/bh-breadcrumb.js';
import '@adornis/buchungsheld-theme/components/tr-button-small.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../../components/bh-color-definitions-editor.js';
import { GlobalSettingsAdapter } from './GlobalSettingsAdapter.js';

@customElement('bh-page-admin-global-settings-colors')
export class BHPageAdminGlobalSettingsColors extends GlobalSettingsAdapter {
  override render() {
    return html`
      <x-flex space="xl">
        <bh-breadcrumb
          .items=${[
            { content: this._translation.translate('settings', 'name'), href: '/admin/settings' },
            { content: 'Farben', active: true },
          ]}
          .additionalAction=${html`
            <tr-button-small icon="save" .action=${async () => this._formControllerV2.validate()}></tr-button-small>
          `}
        ></bh-breadcrumb>
        <bh-color-definitions-editor
          .value=${this._formControllerV2.document?.colorDefinitions}
        ></bh-color-definitions-editor>
      </x-flex>
    `;
  }

  override styles() {
    return [
      ...super.styles(),
      {
        '.color-preview': {
          width: '40px',
          height: '40px',
          borderRadius: '50%',
          background: 'red',
        },
      },
    ];
  }
}
